import { api } from '../../base';
import { getToolsPrefix } from '../../common';
import {
    IFetchForgotPasswordAction,
    LoginPayload,
    IFetchChangePasswordAction,
    IFetchResetPasswordAction,
    IFetchGoogleLoginAction,
} from '../login/redux/interface';

export const fetchLoginApi = (data: LoginPayload) => {
    return api.post({ url: `${getToolsPrefix()}token/`, data });
};

export const fetchForgotPasswordApi = (data: IFetchForgotPasswordAction) => {
    return api.post({ url: `${getToolsPrefix()}password/reset/`, data });
};

export const fetchResetPasswordApi = (data: IFetchResetPasswordAction) => {
    return api.post({ url: `${getToolsPrefix()}password/confirm/`, data });
};
export const fetchChangePasswordApi = (data: IFetchChangePasswordAction) => {
    return api.post({ url: `${getToolsPrefix()}users/change_password/`, data });
};

export const fetchGoogleLoginApi = (data: IFetchGoogleLoginAction) => {
    return api.post({ url: `${getToolsPrefix()}google/login/`, data });
};
